export default __webpack_public_path__ + "media/images/brighteon-social/about/bg_pattern__-a855ac432ccb1ac7727f89540aaf43ba.png";